import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';

import ContentLayoutArtes from './ContentLayoutArtes';

const LayoutArtes = () => {
  return (
    <>
      <Header />
      <ContentLayoutArtes path="layout-artes" />
      <Bottom />
    </>
  );
};

export default LayoutArtes;
